export enum QuickAction {
    AddMeal = 'add-meal',
    SaveWeight = 'save-weight',
    NextInjection = 'next-injection',
    BookConsult = 'book-consult',
}